import { combineReducers } from "redux";
import { types } from "../actions";

const token = (state = "", { type, payload }) => {
  switch (type) {
    case types.SET_TOKEN:
      return payload.token;
    case types.DELETE_TOKEN:
      return "";
    default:
      return state;
  }
};

const expireAt = (state = 0, { type, payload }) => {
  switch (type) {
    case types.SET_TOKEN:
      return payload.expireAt;
    case types.DELETE_TOKEN:
      return 0;
    default:
      return state;
  }
};

const isAccessTokenExpired = (state = false, { type, payload }) =>
  type === types.SET_IS_TOKEN_EXPIRED ? payload : state;

export default combineReducers({
  token,
  expireAt,
  isAccessTokenExpired
});
